import styled from 'styled-components';
import { colors, globals } from 'shared/styles/settings';
import { Flex, Box } from 'rebass';

export const InlineFlex = styled(Flex)`
  display: inline-flex;
`;

export const FlexBox = styled(Flex).attrs(props => ({
  backgroundColor: props.backgroundColor || 'transparent',
  borderRadius: props.borderRadius || '0',
  boxShadow: props.boxShadow ? '0 0 0 1px rgba(63,63,68,.05),0 1px 3px 0 rgba(63,63,68,.15)' : 'none',
  display: props.flex || 'flex',
  height: props.height || 'auto',
  overflowMX: props.overflowMX || 'auto',
}))`
  background-color: ${props => props.backgroundColor};
  border-radius: ${props => props.borderRadius}rem;
  box-shadow: ${props => props.boxShadow};
  display: ${props => props.display};
  height: ${props => props.height};

  @media (max-width: 768px) {
    overflow-x: ${props => props.overflowMX};
  }
`;

export const Container = styled(Box)`
  display: flex;
`;

export const navbarHeight = '3rem';
export const headerHeight = '4.2rem';
export const SidebarWidth = '24rem';
export const appPadding = `${globals.baseSpace}`;

export const AppFrame = styled.div`
  background-color: ${colors.background};
  height: 100%;
  position: relative;
  z-index: 0;
`;

export const Wrapper = styled(Flex)`
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const SidebarWrapper = styled.div`
  border-right: 1px solid ${colors.grayLighter};
  height: calc(100vh - 6em);
  overflow-y: hidden;
  padding-left: ${appPadding};
  padding-right: ${appPadding};
  padding-top: ${appPadding};
  position: relative;
  width: ${SidebarWidth};

  @media (max-width: 1024px) {
    width: 18rem;
  }
`;

export const Page = styled.div`
  height: 100%;
  width: 100%;
  background-color: white;
  padding: 1rem 0;
  overflow: auto;
`;

export const ColumnWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  position: relative;
  width: 100%;
`;

export const Header = styled.div`
  align-items: center;
  background-color: ${colors.white};
  box-shadow: 0 4px 16px rgba(55, 80, 104, 0.19);
  display: flex;
  height: ${headerHeight};
  justify-content: space-between;
  padding: 0 2rem;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: ${props => props.z || 2};

  @media (max-width: 600px) {
    padding: 0 0.75rem;
    /* stylelint-disable */
    height: ${props => props.mobHeight && props.mobHeight};
    /* stylelint-enable */
  }
`;

export const Body = styled.div`
  background-color: ${colors.background};
  height: calc(100vh - 10.5rem);
  overflow-y: auto;
  padding: ${props => props.verticalPadding || 0} 2rem;
  position: absolute;
  top: ${headerHeight};
  width: 100%;
  z-index: ${props => props.z || 1};

  @media (max-width: 768px) {
    padding: 0 1rem;
    /* stylelint-disable */
    top: ${props => props.mobTop && props.mobTop};
    /* stylelint-enable */
  }
`;

export const StyledBody = styled(Flex)`
  height: calc(100vh - 6rem) !important;
  overflow-y: auto;
  padding-top: 5rem !important;
`;
